<!--
 * @Description: 
 * @Author: liulan
 * @Date: 2021-08-04 10:03:32
 * @LastEditors: liulan
 * @LastEditTime: 2021-08-04 10:18:43
 * @FilePath: \xingmahui_front\src\views\contents\tools\feedRecord\components\Title.vue
 * Copyright (C) 2021 liulan. All rights reserved.
-->
<template>
  <div class="header_nav">
    <div class="back"></div>
    <slot v-if="$slots.default"></slot>
  </div>
</template>

<script>
  export default {
    name: 'Title',
    data() {
      return {}
    }
  }
</script>

<style lang="less" scoped>
.header_nav {
  display: flex;
  height: 22px;
  align-items: center;
  line-height: 22px;
  .back {
    width: 4px;
    height: 12px;
    background: #FB6E7E;
    border-radius: 3px;
  }
  .title {
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    margin-left: 6px;
    height: 22px;
  }
}
</style>